export enum ExchangeTaskTargets {
  MAILBOXES_AND_PUBLIC_FOLDERS = 1,
  MAILBOXES = 2,
  PUBLIC_FOLDERS = 3,
}

export enum ExchangeTaskScanFileTypes {
  ALL_FILES = 1,
  APPLICATIONS_ONLY = 2,
  USER_DEFINED_EXTENSIONS = 3,
  ALL_FILES_EXCEPT_SPECIFIC_EXTENSIONS = 4,
}

export enum ExchangeScanTaskTimeUnit {
  HOURS = 1,
  DAYS = 2,
}

export enum ExchangeScanTaskActions {
  REPORT_ONLY = 1,
  REMEDIATE = 2,
  DELETE_FILE = 3,
  MOVE_TO_QUARANTINE = 4,
  REJECT_DELETE_EMAIL = 5,
  REPLACE_FILE = 6,
}

export enum ExclusionsTypes {
  MAILBOX = 1,
  DATABASE = 3,
  PUBLIC_FOLDER = 2,
}

export enum ExclusionsColumnKeys {
  TYPE = 'type',
  SCOPE = 'scope',
  ACTIONS = 'actions',
}

export interface ExclusionGridItem {
  type: ExclusionsTypes;
  scope: string;
}

export enum ExclusionsLightGridEvents {
  REMOVE_EXCLUSION = 'removeExclusion',
}
